import React, { useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
// import useStyles from "./styles";
import { useFormContext } from "react-hook-form";

import { CardElement } from "@stripe/react-stripe-js";
import { useSharedBookReducer } from "../state";

const SurfJoinCount = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, setValue } = useFormContext();

  const setJoinPeople = (e) => {
    setValue("people", e.target.value);
    setValue("joinpeople", e.target.value);
    dispatch({
      type: "MERGE",
      payload: {
        m: { people: e.target.value, joinpeople: e.target.value },
      },
    });
  };

  useEffect(() => {
    setValue("people", bookState.m.joinpeople);
  }, [bookState.m.joinpeople]);

  return (
    <>
      <input
        {...register("joinpeople", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.joinpeople}
      />
      <input
        {...register("people", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.joinpeople}
      />
      {/* 
								<h3 class="title is-5">
									Just you, or having other people join with you?
								</h3>

								<div class="field is-horizontal" v-if="m.type == 'join'">
									<div class="field-body">
										<div class="control is-expanded has-icons-left">
											<div class="select is-fullwidth">
												<select name="people" v-model="m.joinpeople">
													<option value="1">Just Me</option>
													<option value="2">2 total people</option>
													<option value="3">3 total people</option>
												</select>
											</div>
											<span class="icon is-small is-left">
												<i class="fas fa-hashtag"></i>
											</span>
										</div>
									</div>
								</div>

       */}
      <Typography variant="h5" gutterBottom>
        Just you, or having other people join with you?
      </Typography>
      {/* <input
        type="radio"
        name="joinpeople" // "people" ??
        value={bookState.m.joinpeople}
        style={{ display: "none" }}
      ></input> */}

      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <Select value={bookState.m.joinpeople} onChange={setJoinPeople}>
          <MenuItem value="1">Just me</MenuItem>
          <MenuItem value="2">2 total people</MenuItem>
          <MenuItem value="3">3 total people</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default SurfJoinCount;
